import { enableProdMode } from '@angular/core';
import * as ngCore from '@angular/core';
import { environment } from '@Environments';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  bootstrapApplication,
  provideClientHydration
} from '@angular/platform-browser';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TRANSLATE_PROVIDERS } from './app/shared/modules';
import { routes } from './app/app.routes';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeng/themes';

if (environment.production) {
  enableProdMode();
}

const zonelessEnabled =
  (environment as any).zoneless === true ||
  (typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('zoneless') === '1');

const provideZonelessChangeDetection = (ngCore as any)[
  'provideZonelessChangeDetection'
];
const customAura = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e6f7f8',
      100: '#cceff1',
      200: '#99dfe3',
      300: '#66cfd5',
      400: '#3fbfc6',
      500: '#25afb5',
      600: '#1f9499',
      700: '#19797d',
      800: '#135e61',
      900: '#0d4345',
      950: '#0d4345'
    }
  }
});

bootstrapApplication(AppComponent, {
  providers: [
    provideClientHydration(),
    ...(zonelessEnabled && provideZonelessChangeDetection
      ? [provideZonelessChangeDetection()]
      : []),
    providePrimeNG({
      theme: {
        preset: customAura,
        options: {
          darkModeSelector: 'none'
        }
      }
    }),
    ConfirmationService,
    MessageService,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideRouter(routes),
    ...TRANSLATE_PROVIDERS
  ]
}).catch((err) => console.log(err));
